import {t} from 'i18next';
import {FileUpload} from 'primereact';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDetailsContainer from '../../baseContainers/BaseDetailsContainer';
import DivContainer from '../../components/DivContainer';
import InputDropdownComponent from '../../components/inputs/InputDropdownComponent';
import InputNumberComponent from '../../components/inputs/InputNumberComponent';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import YesNoDialog from '../../components/YesNoDialog';
import FileUploadService from '../../services/FileUploadService';
import SettingService from '../../services/SettingService';
import TransportService from '../../services/TransportService';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import StringUtils from '../../utils/StringUtils';
import TransportCreateRequest from './TransportCreateRequest';
import Constants from '../../utils/constants';
import ImageUtils from '../../utils/ImageUtils';
import {Panel} from 'primereact/panel';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import ActionButton from '../../components/ActionButton';
import ActionLink from '../../components/ActionLink';
import moment from 'moment';
import InputCalendarComponent from '../../components/inputs/InputCalendarComponent';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import InputLanguageDropdownComponent from '../../components/inputs/InputLanguageDropdownComponent';
import CompanyTransportService from '../../services/CompanyTransportService';
import CompanyTransportDetailsResponse from './CompanyTransportDetailsResponse';

class CompanyTransportContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new CompanyTransportService());
        this.fileUploadService = new FileUploadService();
        this.state = {
            viewMode: props.viewMode,
            loading: true,
            elementId: props.elementId,
            locale: props.locale,
            globalLocale: props.locale,
            supportedLocales: [],
            element: {
        
                transportToMoneyRatio: [],
                pointsPerKilometer: null,
                pointsPerActivity: null,
                teamMemberPointsPerActivity: null,
            },
            transportTypes: [],
            renderPrevIcon: true,
            renderPrevPhoto: true,
            showConfirmRemoveDialog: false,
            markers: [{position: {lat: 54.312795, lng: 18.651946}}],
            circleCenter: [54.312795, 18.651946],
            markersInitialized: false,
            zoom: 10,
            initialCoordinates: {
                lat: Constants.initialLatitude,
                lng: Constants.initialLongitude,
            },
        };

        this.settingService = new SettingService();
        this.fileUploadService = new FileUploadService();
        this.editorRef = React.createRef();
        this.iconFileUplaodRef = React.createRef();
        this.photoFileUplaodRef = React.createRef();
        this.changeTransportType = this.changeTransportType.bind(this);
        this.transportService = new TransportService();
        
        this.handleMarkerDrag = this.handleMarkerDrag.bind(this);
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    updateElement(data) {
        console.log('Otrzymane dane:', data);
        const {locale} = this.state;
        this.setState(
            {
                globalLocale: locale,
            },
            () => {
                const updatedElement = CompanyTransportDetailsResponse.copy(this.state.element, data, this.state.globalLocale);
                console.log('Po mapowaniu:', updatedElement);
                this.setState(
                    {
                        element: updatedElement,
                    },
                    () => {
                        this.initAfterSetElement();
                    }
                );
            }
        );
    }

    setElement() {
        const {viewMode} = this.props;
        const {elementId, locale} = this.state;
        this.beforeUpdateElement(viewMode, elementId, locale);
    }

    beforeUpdateElement(viewMode, elementId, locale) {
        if (elementId && (viewMode === 'EDIT' || viewMode === 'VIEW')) {
            this.blockUi();
            this.service
                .get(elementId, locale)
                .then((data) => {
                    this.setState({loading: false, locale}, () => this.updateElement(data));
                })
                .catch((err) => {
                    this.handleGetDetailsError(err);
                });
        } else {
            this.setState({loading: false}, this.initAfterSetElement());
        }
    }

    initBeforeSetElement() {
      
        this.settingService
            .getImageSize()
            .then((imgMaxSizeParameter) => {
                this.setState({
                    imgMaxSizeParameter,
                    fileSizeToTranslation: imgMaxSizeParameter * 0.001 + t('global.maxFileSizeUnit'),
                });
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
            });

        this.transportService
            .getTransportDictTypes()
            .then((transportTypes) =>
                this.setState({
                    transportTypes: transportTypes.transportTypes,
                })
            )
            .catch(() => {
                this.showErrorMessage(t('challenge.measureUnitsError'));
            });


    }

    prepareHeaderItems() {
        const {backUrl} = this.props;
        return [
            
            {
                label: t('global.back'),
                // href: AppPrefixUtils.locationHrefUrl(backUrl),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                },
                className: 'gray float-right',
                rendered: true,
            },
        ];
    }

    prepareFooterItems() {
        const {detailUrl, editUrl, locale} = this.props;
        const viewMode = this.viewMode() ? this.viewMode() : this.props.viewMode;
        const editHref = `${editUrl}/${this.state.element?.id}/${locale}`;
        const detailHref = `${detailUrl}/${this.state.element?.id}/${locale}`;
        return [
            {
                label: t('global.save'),
                className: 'float-left',
                onClick: this.handleFormSubmit,
                rendered: viewMode === 'NEW' || viewMode === 'EDIT',
            },
            {
                label: t('global.cancel'),
                onClick: () => {
                    this.setElement();
                    // window.location.href = AppPrefixUtils.locationHrefUrl(detailHref);
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(detailHref));
                },
                className: 'gray',
                rendered: viewMode === 'EDIT',
            },
            {
                label: t('qrcode.edit'),
                // href: AppPrefixUtils.locationHrefUrl(editHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(editHref));
                },
                iconName: 'mdi-pencil',
                className: 'float-right',
                rendered: this.props.viewMode === 'VIEW',
            },
            {
                label: t('qrcode.remove'),
                onClick: this.handleRemove.bind(this),
                className: 'float-right',
                iconName: 'mdi-delete',
                rendered: this.props.viewMode === 'VIEW',
            },
        ];
    }

    goBackUrl() {
        const {backUrl} = this.props;
        return backUrl;
    }

    handleRemove() {
        this.setState({
            showConfirmRemoveDialog: true,
        });
    }

    remove(type, costam, target) {
        if (target.value) {
            this.scrollToTop();
            this.service
                .removeTransport(this.state.elementId)
                .then(() => {
                    const {backUrl} = this.props;
                    this.blockUi();
                    this.persistMessage('success', '', this.getRemoveSucces());
                    // window.location.href = backUrl;
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                })
                .catch((err) => {
                    this.setState({showConfirmRemoveDialog: false});
                    this.showErrorMessage(err.message, 10000);
                    this.unblockUi();
                });
        } else {
            this.setState({showConfirmRemoveDialog: false});
        }
    }

    getAddSucces() {
        return t('transport.createdMessage');
    }
    getUpdateSucces() {
        return t('transport.updatedMessage');
    }
    getRemoveSucces() {
        return t('transport.removedMessage');
    }

    prepareElementBeforeRequest(element) {
        const uploadedFileIcon = this.state.uploadedFileIcon;
        const uploadedFilePhoto = this.state.uploadedFilePhoto;

        if (uploadedFileIcon?.uuid) {
            element.icon = uploadedFileIcon;
            element.iconUuid = uploadedFileIcon?.uuid;
        } else {
            element.iconUuid = element?.icon?.uuid;
        }
        if (uploadedFilePhoto?.uuid) {
            element.photo = uploadedFilePhoto;
            element.photoUuid = uploadedFilePhoto?.uuid;
        } else {
            element.photoUuid = element?.photo?.uuid;
        }
        element.type = element.type?.enumValue;
        

        element.translations = Object.assign({}, element.translations);
        return element;
    }

    createOrUpdate() {
        const {element} = this.state;
        const {elementId, locale} = this.state;
       
        const request = this.prepareElementBeforeRequest(element);
        this.scrollToTop();
        if (this._isMounted) {
            if (!elementId) {
                this.service
                    .add(request)
                    .then((response) => {
                        this.afterAddSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            } else {
                this.service
                    .update(request, locale, elementId)
                    .then((response) => {
                        this.afterUpdateSuccess(response);
                    })
                    .catch((err) => {
                        this.showErrorMessage(err.json.message, 10000);
                    });
            }
        }
    }

    changeLocalLanguage(a, b, c) {
        const {editUrl} = this.props;
        const {elementId} = this.state;
        const locale = c.value;
        // window.location.href = AppPrefixUtils.locationHrefUrl(editUrl + '/' + elementId + '/' + locale);
        this.props.history.push(AppPrefixUtils.locationHrefUrl(editUrl + '/' + elementId + '/' + locale));
        this.beforeUpdateElement('VIEW', elementId, locale);
    }

   

    getBackLabel() {
        return t('global.backToList');
    }

    render() {
        return (
            <div className='container-fluid'>
                <YesNoDialog
                    onChange={this.remove.bind(this)}
                    visible={this.state.showConfirmRemoveDialog}
                    header={t('transport.removeTitle')}
                    name='visible'
                    onHide={() => {
                        this.setState({showConfirmRemoveDialog: false});
                    }}
                >
                    {' '}
                </YesNoDialog>
                {this.renderView()}
            </div>
        );
    }

    getContainerListName() {
        return 'company-transport-list-container';
    }

    breadCrumbItems() {
        return [
            {name: t('transport.listName'), url: '/company-transport-list'},
            {name: t('transport.details'), url: ``},
        ];
    }
    handleMarkerDrag(coordinates, markerIndex) {
        this.handleCoordinatesChange(coordinates);
    }

    handleCoordinatesChange(position) {
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                latitude: position.lat,
                longitude: position.lng,
            },
            circleCenter: [position.lat, position.lng],
        }));
    }
    isNotNewMode() {
        return this.props.viewMode !== 'NEW';
    }
    changeTransportType(a, b, event) {
        const value = event.value;
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                transportType: value,
                id: value.id,
                maximumRewards: value.defaultMaximumRewards,
                steepness: value.defaultSteepness,
                thresholdDistanceInKilometer: value.defaultThresholdDistanceInKilometer,
            },
        }));
    }
    componentDidUpdate(prevProps) {
        if (prevProps.i18n.language !== this.state.globalLocale) {
            this.setState({
                globalLocale: prevProps.i18n.language,
            });
        }
    }
    handleAddMET() {
        const mets = this.state.element.mets;
        if (mets.length !== 0) {
            mets.push({
                speedRangeFrom: mets[mets.length - 1].speedRangeTo + 1,
                speedRangeTo: mets[mets.length - 1].speedRangeTo + 2,
                met: mets[mets.length - 1].met + 1,
            });
        } else {
            mets.push({
                speedRangeFrom: 0,
                speedRangeTo: 0,
                met: 0,
            });
        }
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                mets,
            },
        }));
    }
    handleAddRatio() {
        const ratio = this.state.element.transportToMoneyRatio;

        ratio.unshift({
            multiplier: 0,
            dateFrom: new Date(),
        });

        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                transportToMoneyRatio: ratio,
            },
        }));
    }
    isDisabledRatio(rowIndex) {
        const mets = this.state.element.transportToMoneyRatio;
        const isLast = rowIndex === mets.length - 1;
        return isLast && mets.length > 1;
    }

    isDisabledRange(rowIndex) {
        const mets = this.state.element.mets;
        const isLast = rowIndex === mets.length - 1;
        return !isLast;
    }
    minValueForMet(rowIndex) {
        const mets = this.state.element.mets;
        if (rowIndex !== 0) {
            return mets[rowIndex - 1].met;
        }
        return 0;
    }
    changeValuesAtLowerLevel(rowIndex, mets) {
        const prevLevel = rowIndex - 1;
        if (rowIndex === 0) {
            return;
        }
        mets[prevLevel].speedRangeTo = mets[rowIndex].speedRangeFrom - 1;
    }

    dateFromTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        return (
            <div style={{minWidth: '120px', maxWidth: '180px'}}>
                <InputCalendarComponent
                    id={`dateFrom${rowIndex}`}
                    name='dateFrom'
                    value={rowData.dateFrom}
                    stateField={`element.transportToMoneyRatio[${rowIndex}]`}
                    showLabel={false}
                    onChange={this.handleChange}
                    insideTable
                    viewMode={this.props.viewMode}
                    validator={this.validator}
                    validators='not_required'
                    disabled={this.isDisabledRatio(rowIndex)}
                    showIcon
                />
            </div>
        );
    }

    speedRangeToTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        return (
            <InputNumberComponent
                id={`speedRangeTo${rowIndex}`}
                name='speedRangeTo'
                label='Zakres do KM/h'
                colClass='col-xl-6 col-lg-6 col-md-6 col-sm-12'
                value={rowData.speedRangeTo}
                stateField={`element.mets[${rowIndex}]`}
                validator={this.validator}
                insideTable
                disabled={this.isDisabledRange(rowIndex)}
                showLabel={false}
                validators={`required|number_min:${rowData.speedRangeFrom}|number_max:999`}
                maxFractionDigits={3}
                onChange={this.handleChange}
                viewMode={this.props.viewMode}
            />
        );
    }

    

    ratioMultiplierTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        return (
            <InputNumberComponent
                id='multiplier'
                name='multiplier'
                label='Współczynnik'
                colClass='col-xl-6 col-lg-6 col-md-6 col-sm-12'
                stateField={`element.transportToMoneyRatio[${rowIndex}]`}
                value={rowData.multiplier}
                validator={this.validator}
                showLabel={false}
                insideTable
                disabled={this.isDisabledRatio(rowIndex)}
                validators={`required|number_min:${0}|number_max:9999`}
                maxFractionDigits={3}
                onChange={this.handleChange}
                viewMode={this.props.viewMode}
            />
        );
    }
    calculateTheSameRowIndex() {}

    metTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        return (
            <InputNumberComponent
                id={`met${rowIndex}`}
                name='met'
                label='MET'
                stateField={`element.mets[${rowIndex}]`}
                colClass='col-xl-6 col-lg-6 col-md-6 col-sm-12'
                value={rowData.met}
                validator={this.validator}
                showLabel={false}
                validators={`required|number_min:${this.minValueForMet(rowIndex)}|number_max:999`}
                maxFractionDigits={0}
                insideTable
                onChange={this.handleChange}
                viewMode={this.props.viewMode}
            />
        );
    }

    actionDeleteRatioTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        const {transportToMoneyRatio} = this.state.element;
        return (
            <span>
                <ActionLink
                    iconName='mdi-delete'
                    iconSide='left'
                    iconSize='icon-large'
                    handleClick={() => {
                        const isLast = rowIndex === transportToMoneyRatio.length - 1;
                        transportToMoneyRatio.splice(rowIndex, 1);
                        if (!isLast) {
                            this.changeValuesAtLowerLevel(rowIndex, transportToMoneyRatio);
                        }
                        this.setState((prevState) => ({
                            element: {
                                ...prevState.element,
                                transportToMoneyRatio: transportToMoneyRatio,
                            },
                        }));
                    }}
                    variant='blue'
                    className='edit-blue-link cursor-pointer'
                    key={'delete-button'}
                    rendered={this.props.viewMode !== 'VIEW'}
                />
            </span>
        );
    }

    actionTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        const {mets} = this.state.element;
        return (
            <span>
                <ActionLink
                    iconName='mdi-delete'
                    iconSide='left'
                    iconSize='icon-large'
                    handleClick={() => {
                        const isLast = rowIndex === mets.length - 1;
                        mets.splice(rowIndex, 1);
                        if (!isLast) {
                            this.changeValuesAtLowerLevel(rowIndex, mets);
                        }
                        this.setState((prevState) => ({
                            element: {
                                ...prevState.element,
                                mets: mets,
                            },
                        }));
                    }}
                    variant='blue'
                    className='edit-blue-link cursor-pointer'
                    key={'delete-button'}
                    rendered={this.props.viewMode !== 'VIEW'}
                />
            </span>
        );
    }
    renderDetails() {
        const {locale, renderPrevIcon} = this.state;
        const {elementId} = this.props;
        const uploadOptions = {
            icon: 'none',
            iconOnly: true,
            style: {width: '0px'},
            className: 'invisible',
        };

        return (
            <React.Fragment>
                <div className='row'>
                    <div className='col-md-12 col-sm-12'>
                        <div className='row'>

                            <InputDropdownComponent
                                id='transportId'
                                name='transport'
                                label={t('transport.name')}
                                optionLabel='name'
                                dataKey='transportId'
                                validator={this.validator}
                                validators='required'
                                value={this.state.element.transport}
                                options={this.state.transportTypes}
                                colClass='col-lg-2 col-md-4 col-sm-4'
                                onChange={this.handleChange}
                                viewMode={this.props.viewMode === 'NEW' ? 'NEW' : 'VIEW'}      
                                                  
                            />
                            {this.state.element.transport != null ? 
                             <img
                             src={`${this.service.getPath()}/icon/${
                                 this.state.element?.transport?.iconUuid
                             }?token=${this.authService?.getToken()}`}
                             alt='transport icon'
                             className='product-image'
                             style={{height: '80px', width: 'auto'}}
                         />
                            : <span/>}
                            

                           
                        </div>

                        <div className='row'>
                            <InputNumberComponent
                                id='pointsPerKilometer'
                                name='pointsPerKilometer'
                                label={t('transport.pointsPerKilometer')}
                                colClass='col-xl-3 col-lg-3 col-md-3 col-sm-12'
                                value={this.state.element.pointsPerKilometer}
                                validator={this.validator}
                                validators='required|number_min:0'
                                onChange={this.handleChange}
                                viewMode={this.props.viewMode}
                                maxFractionDigits={1}
                            />
                   
                        
                            
                                <InputNumberComponent
                                    id='pointsPerActivity'
                                    name='pointsPerActivity'
                                    label={t('transport.pointsPerActivity')}
                                    colClass='col-xl-3 col-lg-3 col-md-3 col-sm-12'
                                    value={this.state.element.pointsPerActivity}
                                    validator={this.validator}
                                    validators='required|number_min:0'
                                    onChange={this.handleChange}
                                    viewMode={this.props.viewMode}
                                    maxFractionDigits={3}
                                />
                                {this.state.element.transport?.type === 'CARSHARING' ? (
                                <InputNumberComponent
                                    id='teamMemberPointsPerActivity'
                                    name='teamMemberPointsPerActivity'
                                    label={t('transport.teamMemberPointsPerActivity')}
                                    colClass='col-xl-3 col-lg-3 col-md-3 col-sm-12'
                                    value={this.state.element.teamMemberPointsPerActivity}
                                    validator={this.validator}
                                    validators='required|number_min:0'
                                    onChange={this.handleChange}
                                    viewMode={this.props.viewMode}
                                    maxFractionDigits={3}
                                />
                            ) : null}
                            </div>
                        
                        <div className='row'>
                            <label  className='p-label'  style={{width: '100%'}}>
                                 {t('transport.ratio')}
                            </label>
                       
                           
                                <DataTable
                                    responsiveLayout='scroll'
                                    value={this.state.element.transportToMoneyRatio}
                                    emptyMessage={t('global.noResultsFound')}
                                    className='mb-3'
                                >
                                    <Column
                                        field='multiplier'
                                        header={t('transport.ratio-multiplier')}
                                        body={this.ratioMultiplierTemplate.bind(this)}
                                    ></Column>
                                    <Column field='dateFrom' header={t('transport.currency-multiplier-since')} body={this.dateFromTemplate.bind(this)}></Column>
                                    <Column field='' header='' body={this.actionDeleteRatioTemplate.bind(this)}></Column>
                                </DataTable>
                        </div>
                            <div className='row'>
                                <div className='col-12 text-right'>
                                    <ActionButton
                                        label={t('global.add')}
                                        iconName='mdi-plus'
                                        iconSide='left'
                                        iconSize='icon-large'
                                        variant='blue'
                                        className='mt-3'
                                        key={'add-activity-button'}
                                        handleClick={() => {
                                            this.handleAddRatio();
                                        }}
                                        rendered={this.props.viewMode !== 'VIEW'}
                                    />
                                </div>
                            </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    

}

CompanyTransportContainer.defaultProps = {
    backUrl: '/company-transport-list',
    editUrl: '/company-transport/edit',
    detailUrl: '/company-transport/details',
    lazy: true,
};

CompanyTransportContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
    detailUrl: PropTypes.string,
};

export default withRouter(withTranslation()(CompanyTransportContainer));
